import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { createSeats, updateSeats } from '~/state/modules/planimetry'
import { loadEvent } from '~/state/modules/events'
import { Typography } from '@material-ui/core'
import { PaperContainer } from '~/views/shared'
import { SeatsDistribution } from '../SeatsDistribution'
import { ROUTES } from '~/views/routes'
import { SEATS_STATUS } from 'config/constants'
import history from '~/config/history'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'

export const SeatsCreatePage = ({ onSuccess }) => {
  const { eventId, layoutId, sectorId } = useParams()
  const { pendingCreateSeats, pendingUpdateSeats, sector } = useSelector(
    (state) => state.planimetry
  )
  const { event } = useSelector((state) => state.events)

  const dispatch = useDispatch()

  const handleSubmit = async (values, { setSubmitting }) => {
    const payload = {
      SectorId: sectorId,
      Column: values.Column,
      Row: values.Row,
      Seats: values.Seats.map((seat) => ({
        Column: seat.column,
        Row: seat.row,
        IsSeat: true,
        Status: SEATS_STATUS[seat.status],
        Id: seat.id
      }))
    }
    try {
      setSubmitting(true)
      if (sector.Capacity === 0) {
        await dispatch(createSeats(payload))
        showSnackbarSuccess('Distribución de asientos Creada!')
      } else {
        await dispatch(updateSeats(payload))
        showSnackbarSuccess('Distribución de asientos Actualizada!')
      }
      onSuccess(eventId, layoutId)
    } catch (error) {
      showSnackbarError(error)
    } finally {
      setSubmitting(false)
    }
  }

  const getSectorIndexUrl = () => {
    return ROUTES.ADMIN.EVENTS.SECTORS.INDEX.replace(
      ':eventId',
      eventId
    ).replace(':layoutId', layoutId)
  }

  const values = {
    SectorId: sectorId,
    Seats: [],
    Row: 0,
    Column: 0
  }

  useEffect(() => {
    async function fetchData() {
      await dispatch(loadEvent(eventId))
    }

    fetchData().then()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      {event && (
        <Typography variant='h6' style={{ paddingInline: 8, paddingBottom: 8 }}>
          {`${event?.Title} (${event?.Id})`}{' '}
        </Typography>
      )}
      <PaperContainer
        title={
          <>
            Distribución de asientos del sector{' '}
            <span
              style={{
                display: 'inline-block',
                width: sector?.Color && 12,
                height: sector?.Color && 12,
                backgroundColor: sector?.Color || '',
                borderRadius: '50%',
                marginInline: sector?.Color && 4,
                verticalAlign: 'middle'
              }}
            />
            {`"${sector?.Name ?? '-'}"`}
          </>
        }>
        <SeatsDistribution
          values={values}
          actionText='Crear'
          handleSubmit={handleSubmit}
          actionPending={pendingCreateSeats || pendingUpdateSeats}
          onCancel={() => history.push(getSectorIndexUrl())}
        />
      </PaperContainer>
    </>
  )
}

export default SeatsCreatePage
